import { useClickOutside } from '@mantine/hooks';
import Image from 'next/image';

import CertifyIcon from '../../../public/icons/certify-blue.svg';
import XIcon from '../../../public/icons/x-icon.svg';
import PaymentsLogos from '../../../public/images/payments-logos.png';

import styles from './styles.module.scss';

type SafePurchasePopUpProps = {
  onClose: () => void;
};

const SafePurchasePopUp = ({ onClose }: SafePurchasePopUpProps) => {
  const popUpRef = useClickOutside(onClose);
  return (
    <div className={styles.popUpOverlay}>
      <div className={styles.popUp} ref={popUpRef}>
        <div className={styles.popUpHeadingContainer}>
          <div className={styles.popUpHeading}>
            <Image
              src={CertifyIcon}
              alt="Ikona certyfikatu"
              width={20}
              height={20}
            />
            Patyna.pl gwarantuje bezpieczne zakupy
          </div>
          <button className={styles.popUpCloseButton} onClick={onClose}>
            <Image src={XIcon} alt="Ikona zamknięcia" />
          </button>
        </div>
        <div className={styles.popUpContent}>
          <h4>Ochrona Kupującego</h4>
          <p>
            Na Patyna.pl kupujesz bezpiecznie. Czuwamy nad procesem zamówienia i
            wysyłki produktów. Jeśli jednak coś pójdzie nie tak, możesz na nas
            liczyć.
          </p>
          <p className={styles.ListHeading}>
            Pomożemy Ci błyskawicznie, jeśli:
          </p>
          <ul>
            <li>produkt okaże się niezgodny z opisem i/lub zdjęciami,</li>
            <li>produkt zostanie uszkodzony w transporcie,</li>
            <li>
              przesyłka do Ciebie nie dotarła lub jest niekompletna, zamówienie
            </li>
            <li>zostanie anulowane (szybko zwrócimy Ci pieniądze</li>
          </ul>
          <h4>Gwarancja bezpiecznej dostawy</h4>
          <p>
            Dbamy o to, aby przesyłka dotarła do Ciebie cała i zdrowa. Posiadamy
            wieloletnie doświadczenie w pakowaniu przedmiotów vintage. Ponad 99%
            zamówień złożonych na Patyna.pl dociera do Klientów bez żadnych
            uszkodzeń powstałych podczas transportu.
          </p>
          <p>
            Jeśli pojawią się jakiekolwiek problemy, dołożymy wszelkich starań,
            aby je rozwiązać.
          </p>
          <h4>14 dni na zwrot zamówienia</h4>
          <p>
            Jesteśmy przekonani, że pokochasz nasze perełki vintage. Jeśli
            jednak z jakiegokolwiek powodu chcesz zwrócić zamówiony przedmiot,
            masz na to 14 dni od momentu otrzymania przesyłki. Skontaktuj się z
            nami na: kontakt@patyna.pl.
          </p>
          <h4>Zweryfikowani i profesjonalni sprzedawcy</h4>
          <p>
            Patyna.pl ma dostęp do zaawansowanej sieci dostawców. Większość
            Sprzedawców na Patynie to firmy i doświadczeni profesjonaliści. Aby
            zwiększyć bezpieczeństwo zakupów na naszej platformie, weryfikujemy
            wszystkie nowe zgłoszenia, nie dopuszczając do sprzedaży tych,
            którzy nie spełniają naszych standardów. Jeśli któryś z
            zaakceptowanych Sprzedawców przestaje spełniać standardy obsługi
            Klienta, wyłączamy mu możliwość sprzedaży na Patynie.
          </p>
          <h4>Przyjazna i fachowa obsługa klienta</h4>
          <p>
            Jeśli masz jakiekolwiek pytania dotyczące produktu lub zamówienia,
            napisz do nas na kontakt@patyna.pl.
          </p>
          <h4>Bezpieczne dane i płatności</h4>
          <p>
            Patyna.pl udostępnia bezpieczne i popularne metody płatności
            realizowane przez PayU. Dbamy także o bezpieczeństwo powierzonych
            nam danych, a szczegółowe informacje o ich przetwarzaniu
            udostępniamy w polityce prywatności.
          </p>
        </div>
        <Image src={PaymentsLogos} alt="Loga płatności test" />
      </div>
    </div>
  );
};

export default SafePurchasePopUp;
